<span class="icc-input-wrapper"
    [class.has-value]="value"
    [class.focused]="focused"
    [class.textarea]="type === 'textarea'"
    [class.no-prefix-icon]="!prefixIcon"
    [class.date-picker-left]="datePickerIsVisible && datePickerSide === 'left'"
    >
    <label
        *ngIf="label"
        [for]="name"
        class="icc-input-label"
    >
        {{ label }}
    </label>
    <span class="icc-input-frame" [ngClass]="{'icc-invalid': phoneNumberError || emailError || minLengthError }">

        <span
            *ngIf="prefix"
            class="icc-input-prefix"
        >
            {{ prefix }}
        </span>

        <span
            *ngIf="prefixIcon"
            class="icc-input-prefix-icon"
        >
            <icc-icon [name]="prefixIcon"></icc-icon>
        </span>

        <span
            *ngIf="datePickerIsVisible && datePickerSide === 'left'"
            class="icc-input-tools"
        >
            <icc-icon
                name="date_picker"
                *ngIf="datePickerIsVisible"
                (click)="switchCalendar()"
            ></icc-icon>

        </span>



        <input
            *ngIf="type === 'text' || type === 'password' || type === 'email'"
            [type]="type"
            [attr.name]="name"
            [attr.placeholder]="placeholder"
            [attr.minLength]="minLength"
            [attr.maxLength]="maxLength"
            [attr.pattern]="pattern"
            [readonly]="readonly ? true : null"
            [disabled]="disabled ? true : null"
            [required]="required ? true : null"
            [(ngModel)]="value"
            (change)="onChange($event)"
            (click)="onClick($event)"
            (blur)="handleBlur()"
            (focus)="handleFocused(true)"
            (focusout)="handleFocused(false)"
            (keyup.enter)="$event.target.blur()"
            [attr.autocomplete]="autocomplete"
            #input

        />

        <textarea
            *ngIf="type === 'textarea'"
            [attr.name]="name"
            [attr.placeholder]="placeholder"
            [attr.minLength]="minLength"
            [attr.maxLength]="maxLength"
            [attr.rows]="rows"
            [attr.cols]="cols"
            [readonly]="readonly ? true : null"
            [disabled]="disabled ? true : null"
            [required]="required ? true : null"
            [(ngModel)]="value"
            (change)="onChange($event)"
            (click)="onClick($event)"
            (blur)="handleBlur()"
            (focus)="handleFocused(true)"
            (focusout)="handleFocused(false)"
            #input
        ></textarea>

        <input
            *ngIf="type === 'number'"
            [type]="type"
            [attr.name]="name"
            [attr.placeholder]="placeholder"
            [attr.min]="min"
            [attr.max]="max"
            [attr.step]="step"
            [readonly]="readonly ? true : null"
            [disabled]="disabled ? true : null"
            [required]="required ? true : null"
            [(ngModel)]="value"
            (change)="onChange($event)"
            (click)="onClick($event)"
            (blur)="handleBlur()"
            (focus)="handleFocused(true)"
            (focusout)="handleFocused(false)"
            (keyup.enter)="$event.target.blur()"
            [attr.inputmode]="inputmode"
            [attr.autocomplete]="autocomplete"
            #input

        />

        <input
            *ngIf="type === 'date'"
            [attr.name]="name"
            [placeholder]="placeholder ? placeholder : ('INTERFACE|dd.mm.yyyy' | translate)"
            [min]="min"
            [max]="max"
            [readonly]="readonly ? true : null"
            [disabled]="disabled ? true : null"
            [required]="required ? true : null"
            [(ngModel)]="value"
            (change)="onChange($event)"
            (click)="onClick($event)"
            (blur)="handleBlur()"
            (focus)="handleFocused(true)"
            (focusout)="handleFocused(false)"
            (keyup.enter)="$event.target.blur()"
            #inputDate
            [matDatepicker]="datepicker"
        />

        <label *ngIf="type === 'file'" [for]="name" class="file-input-label" #input>
            {{ placeholder }}
        </label>
        <input
            *ngIf="type === 'file'"
            [type]="type"
            [accept]="accept"
            [attr.id]="name"
            [attr.name]="name"
            [attr.placeholder]="placeholder"
            [attr.minLength]="minLength"
            [attr.maxLength]="maxLength"
            [readonly]="readonly ? true : null"
            [disabled]="disabled ? true : null"
            [required]="required ? true : null"
            [(ngModel)]="value"
            (change)="onChange($event)"
            (click)="onClick($event)"
            (blur)="handleBlur()"
            (focus)="handleFocused(true)"
            (focusout)="handleFocused(false)"
            (keyup.enter)="$event.target.blur()"
            #input
        />

        <span
            *ngIf="suffix"
            [attr.title]="suffixTitle"
            class="icc-input-suffix"
        >
            {{ suffix }}
        </span>

        <span
            *ngIf="clearValueIsVisible || (datePickerIsVisible && datePickerSide === 'right')"
            class="icc-input-tools"
        >
            <icc-icon
                *ngIf="clearValueIsVisible"
                name="close"
                (click)="clearValue()"
            ></icc-icon>

            <icc-icon
                name="date_picker"
                *ngIf="datePickerIsVisible && datePickerSide === 'right'"
                (click)="switchCalendar()"
            ></icc-icon>

        </span>

    </span>
    <div
        class="calendar"
        [ngClass]="{'calendar-popover': calendarPopover}"
    >
        <mat-datepicker #datepicker ></mat-datepicker>
    </div>

    <span
        *ngIf="supportTextIsVisible || inputLengthIsVisible || phoneNumberError || inputDate || requiredError || minLengthError || errorMessage"
        class="icc-input-footer"
    >
        <div>
            <span
                *ngIf="supportTextIsVisible"
                class="icc-input-support-tekst"
            >
                {{supportText}}
            </span>
            <span
                *ngIf="phoneNumberError"
                class="icc-invalid"
            >
                {{phoneNumberErrorMessage}}
            </span>
            <span
                *ngIf="minLengthError"
                class="icc-invalid"
            >
                {{minLengthErrorMessage}}
            </span>
            <span
                *ngIf="requiredError"
                class="icc-invalid__required"
            >
                {{requiredErrorMessage}}
            </span>
            <span
                *ngIf="errorMessage"
                class="icc-invalid"
            >
                {{errorMessage}}
            </span>
            <span *ngIf="inputDate">
                <span
                    *ngIf="inputDate.nativeElement.classList.contains('ng-invalid') && inputDate.nativeElement.classList.contains('ng-touched')"
                    class="icc-invalid"
                >
                    {{dateErrorMessage}}
                </span>
            </span>
        </div>
        <div>
            <span
                *ngIf="inputLengthIsVisible"
                class="icc-input-length"
            >
                {{lengthText}}
            </span>
        </div>
    </span>
</span>
